module.exports = __webpack_public_path__ + "img/c13.e6086cd5.png";